const getObjFromSearchQuery = (queryString = "") => {
  const accumulator: Record<string, string | true> = {};
  const searchParams = new URLSearchParams(queryString);

  // `forEach` rather than `for…of`: iterating a URLSearchParams needs downlevelIteration
  // while tsconfig still targets es5 (see item 2's coupled bumps).
  searchParams.forEach((value, key) => {
    accumulator[key] = value || true;
  });

  return accumulator;
};

export default getObjFromSearchQuery;
